/* eslint-disable jsx-a11y/no-distracting-elements */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import WebMarket from './sub_components/webmarket'
import Fancybook from './fancybook'
import Toast from './sub_components/toast'
import * as orderService from '../services/orderService'
import * as eventService from '../services/eventService'
import * as utilService from '../services/utilService'
import ExpoPopup from './sub_components/expoPopup';
// import CricketBoard from './score_boards/cricketBoard';
// import SoccerBoard from './score_boards/soccerBoard';
// import TennisBoard from './score_boards/tennisBoard';
// import KabaddiBoard from './score_boards/kabaddiBoard';
// import ElectionBoard from './score_boards/electionBoard';
import BetSlipPopup from './sub_components/betSlipPopup';
// import marketMsg from './marketMsg.json';
import * as stringParser from '../util/string.util'
// import socketIOClient from "socket.io-client";
// import { SOCKET_ROOT as ENDPOINT } from '../configs/api';
import GraphicScore from './score_boards/graphicScore';
import BetForm from './sub_components/betForm'
// const scoreSocket = socketIOClient(ENDPOINT);
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import * as authUtil from "../util/auth.util";
let oid = OPERATOR_ID.toLowerCase()
let socket = null
let mBets = []
let umBets = []
let formInterval
let msgInt = null
let dataUpdate = null
class Event extends Component {
    constructor(props) {
        super(props);
        this.state = {
            game: {},
            event: {},
            gameCode: "",
            selected_market: null,
            selcted_bet_option: null,
            matched_bet: [],
            unmatched_bet: [],
            selected_list: "matched",
            frontData: {},
            runners: [],
            showToast: false,
            toastMsg: "",
            toastType: "",
            loading: false,
            fancyMarkets: [],
            lineMarkets: [],
            showExpo: false,
            lineExpo: {},
            tvUrl: "",
            tvShow: false,
            teamSequence: [],
            loadingBet: false,
            mktFeedBooks: {},
            pinnedEvents: [],
            betLimit: 20,
            betLimitMobile: 10,
            betSlipOpen: false,
            deactivatMarkets: [],
            deactivatOrders: [],
            mapped_event_id: "2048524",
            evetList: [],
            mktsList: [],
            fancyFilter: "all",
            showFancy: true,
            hideMkt: [],
            marketMsg: {},
            scoreDetail: {},
            isGraphicScore: false,
            subscribedMarkets: [],
            score_id: "",
            betPlaced: false,
            isEventUpdate: false,
            clientip: "",
            width: document.documentElement.clientWidth
        };
    }
    detectMob() {
        const toMatch = [
            "/Android/i",
            "/webOS/i",
            "/iPhone/i",
            "/iPad/i",
            "/iPod/i",
            "/BlackBerry/i",
            "/Windows Phone/i"
        ];
        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }
    updateBook(marketId, book) {
        let feedBooks = this.state.mktFeedBooks
        feedBooks[marketId] = book
        this.state.mktFeedBooks = feedBooks
    }
    componentWillUnmount() {
        mBets = []
        this.setState({ matched_bet: [] })
        clearInterval(msgInt)
        clearInterval(dataUpdate)
    }
    addBet(bet) {
        this.setState({ loadingBet: true })
        bet.event_name = this.state.game.event.name
        bet.competition_Name = this.state.game.competition.name
        let betData = JSON.parse(localStorage.getItem("betForm"))
        let body = {
            marketId: bet.marketId,
            placeInstruction: {
                orderType: "LIMIT",
                selectionId: parseFloat(betData.selectionId),
                side: !!bet.bet_for ? bet.bet_for.toUpperCase() : 'UNKNOWN',
                limitOrder: {
                    size: parseFloat(parseFloat(betData.bid_amount.toString()).toFixed(2)),
                    price: parseFloat(parseFloat(betData.bid_at.toString()).toFixed(2)),
                    persistenceType: "PERSIST"
                }
            }
        }
        if (!!betData.bid_line && betData.bid_line > 0) {
            body.placeInstruction.selectionId = betData.bid_line
        }
        if (bet.market.bettingType === "BOOKMAKER") {
            orderService.placeBMOrder(body).then((res) => { this.onOrderPlaced(res, bet) })
        } else if (bet.market.bettingType === "LINE") {
            orderService.placeLineOrder(body).then((res) => { this.onOrderPlaced(res, bet) })
        } else if (bet.market.bettingType === "ODDS") {
            orderService.placeOddsOrder(body).then((res) => { this.onOrderPlaced(res, bet) })
        }
        // orderService.placeOrder(body).then((res) => {
        //     if (res.isSuccess !== false && !res.errors) {
        //         if (!!res.exception && !!res.exception.message) {
        //             this.props.notify(res.exception.message, "error")
        //         } else {
        //             this.props.notify("Bet Placed Successfully !", "success")
        //             if (!!res.data && Object.keys(res.data).length > 0) {
        //                 this.orderPlaced(res.data)
        //             }
        //         }
        //         setTimeout(() => {
        //             this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
        //         }, bet.market.betDelay)
        //     } else {
        //         this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
        //         this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
        //     }
        // })
    }
    onOrderPlaced(res, bet) {
        if (res.isSuccess !== false && !res.errors) {
            if (!!res.exception && !!res.exception.message) {
                this.props.notify(res.exception.message, "error")
            } else {
                this.props.notify("Bet Placed Successfully !", "success")
                if (!!res.data && Object.keys(res.data).length > 0) {
                    this.orderPlaced(res.data)
                }
            }
            setTimeout(() => {
                this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
            }, bet.market.betDelay)
        } else {
            this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
            this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
        }
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    onMessage(data) {
        data = JSON.parse(data)
        if (data["e"] === this.props.match.params.event_id) {
            this.setState({ frontData: data })
        }
    }

    async resultDeclered(type, payload) {

        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let matchedBets = this.state.matched_bet

        if (type === "market") {
            if (!!payload && !!payload.marketId) {
                deactivatMarkets.push(payload.marketId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatMarkets.indexOf(bet.marketId) === -1
            })
        }
        else if (type === "order") {

            if (!!payload && !!payload.orderId) {
                deactivatOrders.push(payload.orderId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatOrders.indexOf(bet.orderId) === -1
            })
        }
        else if (type === "rollback") {

            let index = deactivatMarkets.indexOf(payload.marketId)
            if (index > -1) {
                deactivatMarkets.splice(index, 1)
            }

            eventService.getMatchedBets({ "id": this.state.evetList.toString() }).then((res) => {

                if (!!res && res.isSuccess) {
                    mBets = []
                    res.items.forEach((bet) => {
                        if (bet.marketBettingType === "LINE") {
                            bet.runnerName = bet.marketName
                        }
                        mBets.push(bet)
                    })

                    mBets = mBets.filter((bet) => {
                        return deactivatMarkets.indexOf(bet.marketId) === -1
                    })
                    mBets = mBets.filter((bet) => {
                        return deactivatOrders.indexOf(bet.orderId) === -1
                    })

                    this.setState({ matched_bet: mBets })
                }
            })

        }

        this.setState({ matched_bet: matchedBets, deactivatMarkets: deactivatMarkets, deactivatOrders: deactivatOrders })
    }
    showExpo(data) {
        this.setState({ showExpo: true, lineExpo: data })
    }
    hidePopup() {
        this.setState({ showExpo: false, betSlipOpen: false, lineExpo: {} })
    }
    calc(theform) {
        var num = theform.original.value, rounded = theform.rounded
        var with2Decimals = num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        rounded.value = with2Decimals
    }
    async componentDidMount() {
        let selectedEvent = {}
        let teamSequence = []
        let evetData = await eventService.getUserEventById(this.props.match.params.event_id)
        let events = []
        let scoreId = this.props.match.params.event_id
        // this.state.marketMsg = marketMsg
        // let msgs = await eventService.(this.props.match.params.event_id)
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!(!!userData && !!userData.sub)) {
            authUtil.logout();
        }
        this.state.accounts = userData.sub

        let msgs = !!evetData.metadata && !!evetData.metadata.messages ? JSON.parse(evetData.metadata.messages) : {}
        let inActiveMkts = !!evetData.metadata && !!evetData.metadata.inactiveMarkets ? JSON.parse(evetData.metadata.inactiveMarkets) : []

        this.setState({ marketMsg: msgs, score_id: !!evetData.metadata && !!evetData.metadata.scoreUrl ? evetData.metadata.scoreUrl : "", matched_bet: [] })

        localStorage.removeItem("betForm");
        localStorage.removeItem("betExpo");
        if (evetData.metadata && !!evetData.metadata.score) {
            this.setState({ frontData: JSON.parse(evetData.metadata.score) })
            // scoreSocket.emit('score_room', this.props.match.params.event_id)
            // scoreSocket.on("score_room", data => {
            //     this.onMessage(data)
            // });
            // scoreSocket.on('disconnect', () => {
            //     scoreSocket.emit('score_room', this.props.match.params.event_id)
            // })
            this.setState({
                scoreDetail: {
                    evtId: scoreId,
                    type: "4"
                }
            })
        } else if (!!evetData.event && evetData.event.scoreUrl !== "" && (this.props.match.params.event === "1" || this.props.match.params.event === "2")) {
            // let data = false
            scoreId = evetData.event.scoreUrl
            this.setState({
                scoreDetail: {
                    evtId: scoreId,
                    type: this.props.match.params.event
                }
            })
        }
        if (!evetData.catalogues || evetData.catalogues.length === 0) {
            return false
        }
        let runners = evetData.catalogues.filter((mkt) => {
            return mkt.marketType === "MATCH_ODDS"
        })[0]
        if (!runners) {
            runners = evetData.catalogues.filter((mkt) => {
                return mkt.marketType === "BOOKMAKER"
            })[0]
        }
        if (!!runners) {
            runners = runners.runners
            teamSequence = runners.map((r) => { return r = r.name })
        } else {
            runners = evetData.catalogues[0].runners
        }
        this.setState({ runners: runners, teamSequence: teamSequence })
        selectedEvent = events.filter((e, i) => {
            return e.id === this.props.match.params.event_id
        })
        let evtList = [this.props.match.params.event_id]

        evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return mkt.status !== "INACTIVE" && mkt.status !== "CLOSED" && inActiveMkts.indexOf(mkt.marketId) === -1
        })
        let mktsList = evetData.catalogues.map((evt) => { return evt = evt.marketId })
        evetData.catalogues && evetData.catalogues.forEach((market, i) => {
            if (!!evetData.metadata && !!evetData.metadata.books) {
                // let mktBook = stringParser.deSrlz(evetData.metadata.books[market.marketId])
                let mktBookData = JSON.parse(evetData.metadata.books)
                let mktBook = !!mktBookData && mktBookData[market.marketId] ? stringParser.deSrlz(mktBookData[market.marketId]) : null

                evetData.catalogues[i].metadata = {}
                evetData.catalogues[i].metadata.book = mktBook
            } else {
                let baseData = {
                    marketId: market.marketId,
                    status: "OPEN",
                    runners: []
                }
                evetData.catalogues[i].runners.forEach((rnr) => {
                    let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                    baseData.runners.push(data)
                })
                evetData.catalogues[i].metadata = {}
                evetData.catalogues[i].metadata.book = baseData
            }

        })
        evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return !!mkt.metadata && !!mkt.metadata.book && (mkt.provider === "SKY" || mkt.provider === "BETFAIR" || mkt.provider === "BETHUBS")
        })
        var moPos = evetData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
        if (moPos !== -1) {
            let mom = [evetData.catalogues[moPos]]
            evetData.catalogues.splice(moPos, 1)
            evetData.catalogues = mom.concat(evetData.catalogues)
        }
        let fancy_mkts = evetData.catalogues.filter((mkt) => {
            return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
        })
        let line_mkts = []
        evetData.catalogues = evetData.catalogues.filter((mkt) => {
            return mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE"
        })
        fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
        let tvUrl = !!evetData.metadata && !!evetData.metadata.tvUrl ? evetData.metadata.tvUrl : ""
        // if ((this.props.match.params.event === "1" || this.props.match.params.event === "2") && tvUrl.includes("ip=")) {
        //     let ipData = await utilService.getClientIp()
        //     tvUrl = tvUrl + ipData.IPv4
        // }
        if ((this.props.match.params.event === "1" || this.props.match.params.event === "2") && tvUrl.includes("ip=")) {
            let client_ip = await this.getMyIp()
            tvUrl = tvUrl + client_ip
        }
        //self.setState({ tvShow: !self.state.tvShow, tvUrl: tvUrl, tvIP: client_ip })
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        this.setState({ pinnedEvents: pinnedEvents, game: evetData, matched_bet: mBets, unmatched_bet: umBets, gameCode: this.props.match.params.event, event: selectedEvent, loading: false, fancyMarkets: fancy_mkts, lineMarkets: line_mkts, tvUrl: tvUrl, evetList: evtList, mktsList: mktsList }, async () => {
            let self = this
            eventService.getMatchedBets({ "id": evtList.toString() }).then((res) => {
                if (!!res && res.isSuccess) {
                    mBets = []
                    res.items.forEach((bet) => {
                        bet.eventName = evetData.eventName
                        if (bet.marketBettingType === "LINE") {
                            bet.runnerName = bet.marketName
                        }
                        mBets.push(bet)
                    })
                    // mBets = mBets.reverse()
                    this.setState({ matched_bet: [] },
                        () => {
                            this.setState({ matched_bet: mBets })
                        }
                    )
                }
            })
            // msgInt = setInterval(async function mktMsg() {
            //     clearInterval(msgInt)
            //     let msgs = await eventService.getEventMktMessages(self.props.match.params.event_id)
            //     self.setState({ marketMsg: msgs }, () => {
            //         msgInt = setInterval(mktMsg, 60000)
            //     })
            // }, 60000)
            dataUpdate = setInterval(async function detaUpdater() {
                clearInterval(dataUpdate)
                // self.props.socket._callbacks["$market_room"]=[];
                evetData = await eventService.getUserEventById(self.props.match.params.event_id)
                if (!evetData.catalogues) {
                    dataUpdate = setInterval(detaUpdater, 15000)
                    return false
                }

                let inActiveMkts = !!evetData.metadata && !!evetData.metadata.inactiveMarkets ? JSON.parse(evetData.metadata.inactiveMarkets) : []

                evetData.catalogues = !!evetData.catalogues ? evetData.catalogues.filter((mkt) => {
                    return mkt.status !== "INACTIVE" && mkt.status !== "CLOSED" && inActiveMkts.indexOf(mkt.marketId) === -1
                }) : []
                let msgs = !!evetData.metadata && !!evetData.metadata.messages ? JSON.parse(evetData.metadata.messages) : {}
                let mktsList = evetData.catalogues.map((evt) => { return evt = evt.marketId })
                evetData.catalogues && evetData.catalogues.forEach((market, i) => {
                    if (!!evetData.metadata && !!evetData.metadata.books) {
                        // let mktBook = stringParser.deSrlz(evetData.metadata.books[market.marketId])
                        let mktBookData = JSON.parse(evetData.metadata.books)
                        let mktBook = !!mktBookData && mktBookData[market.marketId] ? stringParser.deSrlz(mktBookData[market.marketId]) : null

                        evetData.catalogues[i].metadata = {}
                        evetData.catalogues[i].metadata.book = mktBook
                    } else {
                        let baseData = {
                            marketId: market.marketId,
                            status: "OPEN",
                            runners: []
                        }
                        evetData.catalogues[i].runners.forEach((rnr) => {
                            let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                            baseData.runners.push(data)
                        })
                        evetData.catalogues[i].metadata = {}
                        evetData.catalogues[i].metadata.book = baseData
                    }
                })
                evetData.catalogues = !!evetData.catalogues ? evetData.catalogues.filter((mkt) => {
                    return !!mkt.metadata && !!mkt.metadata.book && (mkt.provider === "SKY" || mkt.provider === "BETFAIR" || (mkt.provider === "BETHUBS"))
                }) : []
                var moPos = evetData.catalogues.findIndex(function (mkt) { return mkt.provider === "BETFAIR" && mkt.marketType === "MATCH_ODDS" });
                if (moPos !== -1) {
                    let mom = [evetData.catalogues[moPos]]
                    evetData.catalogues.splice(moPos, 1)
                    evetData.catalogues = mom.concat(evetData.catalogues)
                }
                let fancy_mkts = evetData.catalogues.filter((mkt) => {
                    return (mkt.marketType.substring(0, 3) === "SES" || mkt.bettingType === "LINE") && !!mkt.metadata && !!mkt.metadata.book && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
                })
                evetData.catalogues = evetData.catalogues.filter((mkt) => {
                    return mkt.marketType.substring(0, 3) !== "SES" && mkt.bettingType !== "LINE"
                })
                fancy_mkts = fancy_mkts.sort((a, b) => a.marketId - b.marketId);
                self.setState({ game: {}, isEventUpdate: true }, () => {
                    dataUpdate = setInterval(detaUpdater, 15000)
                    self.setState({ game: Object.assign({}, evetData), fancyMarkets: Object.assign([], fancy_mkts), mktsList: mktsList, marketMsg: msgs }, () => {
                        self.setState({ isEventUpdate: false })
                    })
                })
            }, 15000)
        })
    }

    async getMyIp() {
        let ip = ""
        await this.text('https://www.cloudflare.com/cdn-cgi/trace').then(data => {
            data = data.split("\n")
            data.forEach((str) => {
                if (str.includes("ip=")) {
                    ip = str.split("ip=")[1]
                }
            })
        });
        return ip
    }
    betForm(market, bet, clicked) {
        let self = this
        if (this.state.loadingBet === true) {
            return false
        }
        if (market === null && bet === null) {
            localStorage.removeItem("betForm");
            localStorage.removeItem("betExpo");
        }
        this.setState({ selected_market: market, selcted_bet_option: bet }, () => {
            if (market !== null && bet !== null && clicked) {
                if (window.innerWidth > 767) {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtns").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtns").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(0, window.scrollY + 70)
                    }
                } else {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtnsMob").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtnsMob").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(window.scrollY, window.scrollY + 235)
                    }
                    // document.getElementById("betFormBtnsMob").style.top = window.pageYOffset+(screenHeight/2)
                    // let yOffset = (screenHeight / 2) - window.pageYOffset + 235
                    // myBetForm = myBetForm + 235
                    // if (myBetForm < yOffset) {
                    //     window.scrollTo(0, window.scrollY + 235)
                    // } else {
                    //     window.scrollTo(0, window.scrollY)
                    // }
                }
            }
            clearTimeout(formInterval)
            formInterval = setTimeout(function intetvalBetForm() {
                if (self.state.selected_market === market && self.state.selcted_bet_option === bet) {
                    self.betForm(null, null)
                }
            }, 10000)
        })
    }
    toggleMultiMarket(eventId) {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        let eventIndex = pinnedEvents.indexOf(eventId)
        if (eventIndex === -1) {
            pinnedEvents.push(eventId)
        } else {
            pinnedEvents.splice(eventIndex, 1)
        }
        localStorage.setItem("pinnedEvents", pinnedEvents.toString())
        this.setState({ pinnedEvents: pinnedEvents })
    }
    toggleOpenMkt(mktId) {
        let hideMkt = this.state.hideMkt
        let mktIndex = hideMkt.indexOf(mktId)
        if (mktIndex === -1) {
            hideMkt.push(mktId)
        } else {
            hideMkt.splice(mktIndex, 1)
        }
        this.setState({ hideMkt: hideMkt })
    }
    arrayGroupBy(ary, attr) {
        let group = ary.reduce((r, a) => {
            r[a[attr]] = [...r[a[attr]] || [], a];
            return r;
        }, {});
        return group
    }
    orgenizedFancy(markets) {
        if (!markets) {
            return {}
        }
        let newObj = {}

        if (!!markets["THREE_SELECTIONS"]) {
            newObj["THREE_SELECTIONS"] = markets["THREE_SELECTIONS"]
            delete markets["THREE_SELECTIONS"]
        }
        if (!!markets["1ST_INNINGS_RUNS"]) {
            newObj["1ST_INNINGS_RUNS"] = markets["1ST_INNINGS_RUNS"]
            delete markets["1ST_INNINGS_RUNS"]
        }
        if (!!markets["2ND_INNINGS_RUNS"]) {
            newObj["2ND_INNINGS_RUNS"] = markets["2ND_INNINGS_RUNS"]
            delete markets["2ND_INNINGS_RUNS"]
        }
        if (!!markets["SINGLE_OVER"]) {
            newObj["SINGLE_OVER"] = markets["SINGLE_OVER"]
            delete markets["SINGLE_OVER"]
        }
        if (!!markets["OVERS"]) {
            newObj["OVERS"] = markets["OVERS"]
            delete markets["OVERS"]
        }
        if (!!markets["BALL_BY_BALL"]) {
            newObj["BALL_BY_BALL"] = markets["BALL_BY_BALL"]
            delete markets["BALL_BY_BALL"]
        }
        if (!!markets["BATSMAN"]) {
            newObj["BATSMAN"] = markets["BATSMAN"]
            delete markets["BATSMAN"]
        }
        if (!!markets["ODD_EVEN"]) {
            newObj["ODD_EVEN"] = markets["ODD_EVEN"]
            delete markets["ODD_EVEN"]
        }
        if (!!markets["OTHERS"]) {
            newObj["OTHERS"] = markets["OTHERS"]
            delete markets["OTHERS"]
        }
        newObj = { ...newObj, ...markets }
        let fancys = []
        Object.keys(newObj).forEach((type) => {
            newObj[type] = newObj[type].sort((a, b) => {
                return a.sortPriority - b.sortPriority;
            });
            fancys = fancys.concat(newObj[type])
        })
        return fancys
    }
    applyFancyFilter(flt) {
        this.setState({ fancyFilter: "" }, () => {
            this.setState({ fancyFilter: flt })
        })
    }
    fancyFilterApply(mktList) {
        let filter = this.state.fancyFilter
        if (filter !== "all") {
            mktList = mktList.filter((mkt, i) => {
                return mkt.marketType === filter
            })
        }
        return mktList
    }
    orderPlaced(ord) {
        let res = [ord]
        if (res[0].marketBettingType === "LINE" && res[0].marketName) {
            res[0].runnerName = res[0].marketName
        }
        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let data = res.concat(this.state.matched_bet)
        data = data.filter((bet) => {
            return deactivatMarkets.indexOf(bet.marketId) === -1
        })
        data = data.filter((bet) => {
            return deactivatOrders.indexOf(bet.orderId) === -1
        })
        this.setState({ matched_bet: data, betPlaced: true })
    }
    updateXScore(data) {
        let ftdata = this.state.frontData
        Object.keys(data).forEach((key) => {
            if (key === "ps" && !!data.ps && !!data.ps.TN && this.props.match.params.event === "1") {
                Object.keys(data.ps.TN).forEach((k) => {
                    if (!ftdata.ps) {
                        ftdata.ps = {
                            TN: {}
                        }
                    }
                    ftdata.ps.TN[k] = data.ps.TN[k]
                })
            } else if (key === "ps" && this.props.match.params.event === "2") {
                Object.keys(data.ps).forEach((k) => {
                    ftdata.ps[k] = data.ps[k]
                })
            } else {
                if (key === "dr" && !!ftdata.dr && !!data.dr && ftdata.dr.s !== data.dr.s) {
                    ftdata.lastUpdated = new Date()
                }
                ftdata[key] = data[key]
            }
        })
        this.setState({ frontData: {} }, () => {
            this.setState({ frontData: ftdata })
        })
    }
    updateSubscribedMarkets(mkt) {
        let mktList = this.state.subscribedMarkets
        mktList.push(mkt)
        this.setState({ subscribedMarkets: mktList })
    }
    updateSocket(skt) {
        socket = skt
    }
    render() {
        let fancyMarkets = this.arrayGroupBy(this.state.fancyMarkets, "marketType")
        fancyMarkets = this.orgenizedFancy(fancyMarkets)
        let fmkt = this.arrayGroupBy(fancyMarkets, "marketType")
        let maketTypeList = Object.keys(fmkt).map((fnc, i) => { return fnc = { mkt: fnc, count: fmkt[fnc].length } })
        fancyMarkets = this.fancyFilterApply(fancyMarkets)
        let bet_list = this.state.matched_bet

        let runnerName = ""
        let jokeyName = ""
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} updateBetplaceStatus={() => { this.setState({ betPlaced: false }) }} betPlaced={this.state.betPlaced} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSocket={(skt) => { this.updateSocket(skt) }} onMessage={(data) => { this.onMessage(data) }} updateXScore={(data) => { this.updateXScore(data) }} scoreData={this.state.scoreDetail} orderPlaced={(ord) => { this.orderPlaced(ord) }} resultDeclered={(type, payload) => { this.resultDeclered(type, payload) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                    <div className="col-centersdetails markets">
                        <div className="">
                            <div className=" live-match">
                                <div className="sub_path center-box crname">
                                    <p>
                                        <a id="multiMarketPin" className="multimarket-pin" title="Remove from Multi Markets" ><i className="fa fa-thumb-tack" aria-hidden="true"></i></a>
                                        <span>AUS</span>
                                    </p>
                                </div>
                                <div className="sub_path center-box crname ">
                                    <p className='horsetitlebg'>
                                        <span>Pinjarra (AUS) 17th Jan</span>
                                        <span className="f-right">17/01/2022 11:35</span>
                                    </p>
                                </div>
                            </div>
                            <div className="live-match">
                                <div className="sub_path center-box crname">
                                    <p>
                                        <a id="multiMarketPin" className="multimarket-pin" title="Remove from Multi Markets"><i className="fa fa-thumb-tack" aria-hidden="true"></i></a>
                                        <span>Win Market</span><span className="f-right min-max">Min: 100 | Max: 100000 <span className={"f-right pl-3"}><i className="fa fa-minus" aria-hidden="true"></i> </span></span>
                                    </p>
                                </div>
                                <div className="game-wrap col3">
                                    <table className="table w-100 game-list-col eventdetails racedetails bets mb-0 horsemb-75">
                                        <tbody>
                                            <tr className="bet-all-new">
                                                <td className="w-55 pb-0">&nbsp;</td>
                                                <td className="w-45 pb-0">
                                                    <div>
                                                        <div className="w-50 float-left ">
                                                            <a id="btnBack" className="btn-back back-light-bg1 mobile-hide bg-trans" side="Back"> &nbsp;</a>
                                                            <a id="btnBack" className="btn-back back-light-bg mobile-hide bg-trans" side="Back">&nbsp;</a>
                                                            <a id="backAll" className="back-all"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/transparent.gif"} /><span className="f11">Back</span></a>
                                                        </div>
                                                        <div className="w-50 float-left">
                                                            <a id="layAll" className="lay-all"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/transparent.gif"} /><span className="f11">Lay</span></a>
                                                            <a id="btnBack" className="btn-lay lay-light-bg mobile-hide bg-trans" side="lay"> &nbsp;</a>
                                                            <a id="btnLay" className="btn-lay lay-light-bg1 mobile-hide bg-trans" side="lay"> &nbsp;</a>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <>
                                                <tr>
                                                    <td className="w-55">
                                                        <ul className='horseracing'>
                                                            <li id='clothNumberAlpha'>1</li>
                                                            <li id='stallDraw'>(10)</li>
                                                        </ul>
                                                        <div id='uniform' className='uniform mobile-hide'><img src="https://content-cache.cdnbf.net/feeds_images/Horses/SilkColours/c20220117-Queanbeyan (AUS)-T/1551348.png" /></div>
                                                        <div className="in-play-title d-inline-block horse-inplay-title">

                                                            {this.state.width > 991 ?
                                                                <ul className='horse-name'>
                                                                    <li id='runnerName'>{runnerName}</li>
                                                                    <li id='jockyName'>{jokeyName}</li>
                                                                </ul> :
                                                                this.state.width >= 768 && (runnerName.length < 22 && jokeyName.length < 22) ?
                                                                    <ul className='horse-name'>
                                                                        <li id='runnerName'>{runnerName}</li>
                                                                        <li id='jockyName'>{jokeyName}</li>
                                                                    </ul> :
                                                                    this.state.width >= 575 && (runnerName.length < 45 && jokeyName.length < 45) ?
                                                                        <ul className='horse-name'>
                                                                            <li id='runnerName'>{runnerName}</li>
                                                                            <li id='jockyName'>{jokeyName}</li>
                                                                        </ul> :
                                                                        this.state.width >= 500 && (runnerName.length < 37 && jokeyName.length < 37) ?
                                                                            <ul className='horse-name'>
                                                                                <li id='runnerName'>{runnerName}</li>
                                                                                <li id='jockyName'>{jokeyName}</li>
                                                                            </ul> :
                                                                            this.state.width >= 469 && (runnerName.length < 37 && jokeyName.length < 37) ?
                                                                                <ul className='horse-name'>
                                                                                    <li id='runnerName'>{runnerName}</li>
                                                                                    <li id='jockyName'>{jokeyName}</li>
                                                                                </ul> :
                                                                                this.state.width >= 414 && (runnerName.length < 37 && jokeyName.length < 37) ?
                                                                                    <ul className='horse-name'>
                                                                                        <li id='runnerName'>{runnerName}</li>
                                                                                        <li id='jockyName'>{jokeyName}</li>
                                                                                    </ul> :
                                                                                    this.state.width >= 390 && (runnerName.length < 37 && jokeyName.length < 37) ?
                                                                                        <ul className='horse-name'>
                                                                                            <li id='runnerName'>{runnerName}</li>
                                                                                            <li id='jockyName'>{jokeyName}</li>
                                                                                        </ul> :
                                                                                        this.state.width >= 375 && (runnerName.length < 37 && jokeyName.length < 37) ?
                                                                                            <ul className='horse-name'>
                                                                                                <li id='runnerName'>{runnerName}</li>
                                                                                                <li id='jockyName'>{jokeyName}</li>
                                                                                            </ul> :
                                                                                            this.state.width >= 374 && (runnerName.length < 10 && jokeyName.length < 10) ?
                                                                                                <ul className='horse-name'>
                                                                                                    <li id='runnerName'>{runnerName}</li>
                                                                                                    <li id='jockyName'>{jokeyName}</li>
                                                                                                </ul> :
                                                                                                this.state.width >= 320 && (runnerName.length < 10 && jokeyName.length < 10) ?
                                                                                                    <ul className='horse-name'>
                                                                                                        <li id='runnerName'>{runnerName}</li>
                                                                                                        <li id='jockyName'>{jokeyName}</li>
                                                                                                    </ul> :
                                                                                                    <marquee scrollamount="2" behavior="scroll">
                                                                                                        <ul className='horse-name'>
                                                                                                            <li id='runnerName'>{runnerName}</li>
                                                                                                            <li id='jockyName'>{jokeyName}</li>
                                                                                                        </ul>
                                                                                                    </marquee>
                                                            }
                                                            <dl id="horseInfoHover" className="horse_info-hover">
                                                                <dt>Trainer:</dt>
                                                                <dd id="trainerName">Chris Gordon</dd>
                                                                <dt>Age/Weight:</dt>
                                                                <dd id="ageWeight">6 / 11-8</dd>
                                                                <dt>Form:</dt>
                                                                <dd id="form">2</dd>
                                                                <dt>Days since last run:</dt>
                                                                <dd id="daysSinceLastRun">77</dd>
                                                                <dt>Jockey claim:</dt>
                                                                <dd id="jockeyClam">N/A</dd>
                                                                <dt>Wearning:</dt>
                                                                <dd id="wearing">N/A</dd>
                                                            </dl>
                                                            {/* <span className="match-odds font-weight-bold" style={{ color: "green" }} >70.00</span> */}
                                                        </div>
                                                        <span className={"float-right font-weight-bold"} style={{ paddingTop: "1rem", color: "green" }} >100000</span>



                                                    </td>
                                                    <td className="w-45">
                                                        <div>
                                                            <div className="w-50 float-left ">
                                                                <a id="btnBack" className="btn-back back-light-bg1 mobile-hide" side="Back" >
                                                                    <div style={{ minHeight: "12px" }} >2.4</div>
                                                                    <span className="bid-price-small">43.7k</span>
                                                                </a>
                                                                <a id="btnBack" className="btn-back back-light-bg mobile-hide" side="Back" >
                                                                    <div style={{ minHeight: "12px" }} >2.42</div>
                                                                    <span className="bid-price-small">5122.7k</span>
                                                                </a>
                                                                <a id="btnBack" className="btn-back" side="Back" >
                                                                    <div style={{ minHeight: "12px" }} >2.44</div>
                                                                    <span className="bid-price-small">425.7k</span>
                                                                </a>
                                                            </div>
                                                            <div className="w-50 float-left">
                                                                <a id="btnBack" className="btn-lay" side="lay">
                                                                    <div style={{ minHeight: "12px" }} >2.46</div>
                                                                    <span className="ask-price-small">1.8k</span>
                                                                </a>
                                                                <a id="btnBack" className="btn-lay lay-light-bg mobile-hide" side="lay">
                                                                    <div style={{ minHeight: "12px" }} >2.48</div>
                                                                    <span className="ask-price-small">31.8k</span>
                                                                </a>
                                                                <a id="btnBack" className="btn-lay lay-light-bg1 mobile-hide" side="lay">
                                                                    <div style={{ minHeight: "12px" }} >2.5</div>
                                                                    <span className="ask-price-small">1878.8k</span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="w-55">
                                                        <ul className='horseracing'>
                                                            <li id='clothNumberAlpha'>1</li>
                                                            <li id='stallDraw'>(10)</li>
                                                        </ul>
                                                        <div id='uniform' className='uniform mobile-hide'><img src="https://content-cache.cdnbf.net/feeds_images/Horses/SilkColours/c20220117-Queanbeyan (AUS)-T/1551348.png" /></div>
                                                        <div className="in-play-title d-inline-block">
                                                            <ul className='horse-name'>
                                                                <li id='runnerName'>2. Mouse Almighty</li>
                                                                <li id='jockyName'>Molly Bourke</li>
                                                            </ul>
                                                            <dl id="horseInfoHover" className="horse_info-hover">
                                                                <dt>Trainer:</dt>
                                                                <dd id="trainerName">Chris Gordon</dd>
                                                                <dt>Age/Weight:</dt>
                                                                <dd id="ageWeight">6 / 11-8</dd>
                                                                <dt>Form:</dt>
                                                                <dd id="form">2</dd>
                                                                <dt>Days since last run:</dt>
                                                                <dd id="daysSinceLastRun">77</dd>
                                                                <dt>Jockey claim:</dt>
                                                                <dd id="jockeyClam">N/A</dd>
                                                                <dt>Wearning:</dt>
                                                                <dd id="wearing">N/A</dd>
                                                            </dl>
                                                            {/* <span className="match-odds font-weight-bold" style={{ color: "green" }} >70.00</span> */}

                                                        </div>
                                                        <span className={"float-right font-weight-bold"} style={{ paddingTop: "1rem", color: "red" }} >-100000</span>

                                                    </td>
                                                    <td className="w-45">
                                                        <div>
                                                            <div className="w-50 float-left ">
                                                                <a id="btnBack" className="btn-back back-light-bg1 mobile-hide" side="Back" >
                                                                    <div style={{ minHeight: "12px" }} >2.4</div>
                                                                    <span className="bid-price-small">43.7k</span>
                                                                </a>
                                                                <a id="btnBack" className="btn-back back-light-bg mobile-hide" side="Back" >
                                                                    <div style={{ minHeight: "12px" }} >2.42</div>
                                                                    <span className="bid-price-small">5122.7k</span>
                                                                </a>
                                                                <a id="btnBack" className="btn-back" side="Back" >
                                                                    <div style={{ minHeight: "12px" }} >2.44</div>
                                                                    <span className="bid-price-small">425.7k</span>
                                                                </a>
                                                            </div>
                                                            <div className="w-50 float-left">
                                                                <a id="btnBack" className="btn-lay" side="lay">
                                                                    <div style={{ minHeight: "12px" }} >2.46</div>
                                                                    <span className="ask-price-small">1.8k</span>
                                                                </a>
                                                                <a id="btnBack" className="btn-lay lay-light-bg mobile-hide" side="lay">
                                                                    <div style={{ minHeight: "12px" }} >2.48</div>
                                                                    <span className="ask-price-small">31.8k</span>
                                                                </a>
                                                                <a id="btnBack" className="btn-lay lay-light-bg1 mobile-hide" side="lay">
                                                                    <div style={{ minHeight: "12px" }} >2.5</div>
                                                                    <span className="ask-price-small">1878.8k</span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </td>

                                                </tr>

                                            </>

                                            <tr className="">
                                                <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i>hello massage</span></td>
                                            </tr>

                                            {/* <BetForm loadingBet={this.props.loadingBet} notify={(msg, type) => { this.props.notify(msg, type) }} eventMarket={{}} selcted_bet_option={this.props.selcted_bet_option} curBets={this.props.curBets} updateExpo={(expo) => { this.updateExpo(expo) }} selectionId={this.state.selectionId} runner_name={this.state.runner_name} bid_at={this.state.bid_at} betForm={this.props.betForm}  /> */}

                                        </tbody>
                                    </table>

                                </div>
                            </div>


                            hi
                            <div className="live-match livetv">
                                <div className="center-box mt-1">
                                    <div className="container-fluid titbg">
                                        <div className="w-100 float-left">
                                            <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                            {bet_list.length > this.state.betLimitMobile && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                        </div>
                                    </div>
                                    {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {bet_list.map((bet, i) => {
                                                    return (
                                                        <>
                                                            {i < this.state.betLimitMobile && <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                                <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                                <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                            </tr>}
                                                        </>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                    {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                        <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                            <thead>
                                                <tr className="bg-dark text-white">
                                                    <th>Matched Bet</th>
                                                    <th>Odds</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.unmatched_bet.map((bet) => {
                                                    return (
                                                        <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>{/* <td><img alt="" style={{ marginLeft: "38%" }} src={require('../images/close.png')} /></td> */}
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`col-right ${(!!accData && Object.keys(accData).length > 0) ? '' : 'col-right-login'}`}>
                        <div className="sub_path over-wrap">
                            {!!this.state.tvUrl && this.state.tvUrl !== "" && <><div className="center-box mb-1 inline">
                                <p>Live TV
                                    <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onMouseDown={() => { this.setState({ tvShow: !this.state.tvShow }) }}>
                                        <input type="checkbox" className="custom-control-input" checked={this.state.tvShow} />
                                        <label className="custom-control-label" for="customSwitches"></label>
                                    </div>
                                </p>
                            </div>
                                {!!this.state.tvShow && <div className="mb-0 tviframe"> <iframe title={"iframe mobile"} key={"iframe_mob"} id='fp_embed_player' src={this.state.tvUrl} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' height='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe></div>}</>}
                            <div className="center-box">
                                <div className="container-fluid titbg">
                                    <div className="w-100 float-left">
                                        <span onClick={() => { this.setState({ selected_list: "matched" }) }} className={this.state.selected_list === "matched" ? "betslip-btn active" : "betslip-btn"}>Matched Bet</span>
                                        {bet_list.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                    </div>
                                </div>
                                {this.state.selected_list === "matched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bet_list.map((bet, i) => {
                                                return (
                                                    <>
                                                        {i < this.state.betLimit && <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                            <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                        </tr>}
                                                    </>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                                {this.state.selected_list === "unmatched" && <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.unmatched_bet.map((bet) => {
                                                return (
                                                    <tr className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerName + " (" + bet.price + ")" : bet.runnerName + " - " + bet.marketName}</td>
                                                        <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                        <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>}
                            </div>
                        </div>
                    </div>
                    {this.state.showExpo && <ExpoPopup lineExpo={this.state.lineExpo} hidePopup={() => { this.hidePopup() }} />}
                    {this.state.betSlipOpen && <BetSlipPopup bets={bet_list} hidePopup={() => { this.hidePopup() }} />}
                </div>
            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Event);